// Typed wrappers around the agent CRUD endpoints. We import DTOs from
// @cortex/shared so the client and server speak the same shape — drift
// breaks compile, not runtime.

import type {
  Agent,
  CreateAgentInput,
  CreateSampleAgentResult,
  MintPlaygroundSessionResult,
  UpdateAgentInput,
} from '@cortex/shared';
import type { ApiClient } from '../api-client.js';

interface AgentsList {
  readonly agents: readonly Agent[];
}

export const agentsApi = {
  list: (api: ApiClient) => api.get<AgentsList>('/v1/agents'),
  get: (api: ApiClient, id: string) => api.get<Agent>(`/v1/agents/${id}`),
  create: (api: ApiClient, body: CreateAgentInput) =>
    api.post<Agent>('/v1/agents', body),
  update: (api: ApiClient, id: string, body: UpdateAgentInput) =>
    api.patch<Agent>(`/v1/agents/${id}`, body),
  remove: (api: ApiClient, id: string) => api.del<undefined>(`/v1/agents/${id}`),
  // One-click "Cortex Demo" agent for non-tech onboarding. Idempotent —
  // the dashboard can call it without checking for existence first.
  createSample: (api: ApiClient) =>
    api.post<CreateSampleAgentResult>('/v1/agents/sample', {}),
  // Mints a session for the in-dashboard playground (bypasses the
  // public Origin allowlist).
  mintPlaygroundSession: (api: ApiClient, agentId: string) =>
    api.post<MintPlaygroundSessionResult>(
      `/v1/agents/${agentId}/playground-session`,
      {},
    ),
} as const;

export const AGENTS_QUERY_KEY = ['agents'] as const;
export const agentQueryKey = (id: string) => ['agent', id] as const;
